package one.healthium.data.user.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class UserPurchasesDto(
    @SerialName("subscription") val subscription: String? = null,
    @SerialName("purchase_type") val purchaseType: String? = null,
    @SerialName("subscription_id") val subscriptionId: String? = null,
)